import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Tabs from 'components/application/Tabs';

import TeamsSidePanelMembersTab from 'components/teams/TeamsSidePanelMembersTab';

export default function TeamSidePanelShow({
  canLoadMoreTeamMembers,
  isFetchingTeamMembers,
  onLoadMoreTeamMembers,
  sidePanelIsOpen,
  team,
  teamCompanyName,
  teamMembers,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const [activeTab, setActiveTab] = useState('members');

  if (sidePanelIsOpen && activeTab !== 'members') setActiveTab('members');

  return (
    <div className='popup__body-show'>
      <h2 className='popup__body-header popup__body-header--height-unset truncated-text-container--wrapped truncated-text-container--five-lines tw-max-h-[140px] tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900'>
        {team.name}
      </h2>
      <h3 className='popup__body-header popup__body-header--sub truncated-text-container truncated-text-container--block tw-text-m tw-font-normal tw-tracking-auto'>
        {teamCompanyName}
      </h3>
      <hr className='tw-mb-0 tw-mt-8 tw-h-px tw-border-0 tw-bg-grey-100' />

      <div className='popup__body-content tw-p-0'>
        <Tabs
          activeTab={activeTab}
          modifiers={['panelled']}
          navClassName='tw-bg-grey-050'
          onTabClick={setActiveTab}
        >
          <TeamsSidePanelMembersTab
            canLoadMoreTeamMembers={canLoadMoreTeamMembers}
            id='members'
            isFetchingTeamMembers={isFetchingTeamMembers}
            key='membersTab'
            label={i18nTShared('members')}
            onLoadMoreTeamMembers={onLoadMoreTeamMembers}
            teamMembers={teamMembers}
          />
        </Tabs>
      </div>
    </div>
  );
}

TeamSidePanelShow.propTypes = {
  team: PropTypes.object.isRequired,
  teamCompanyName: PropTypes.string.isRequired,
  teamMembers: PropTypes.object.isRequired,
  sidePanelIsOpen: PropTypes.bool,
  canLoadMoreTeamMembers: PropTypes.bool.isRequired,
  onLoadMoreTeamMembers: PropTypes.func.isRequired,
  isFetchingTeamMembers: PropTypes.bool.isRequired,
};
